






















import { Component, Vue } from 'vue-property-decorator'

import AuthModal from '@/components/AuthModal.vue'
import ForgotPasswordForm from '@/components/ForgotPasswordForm.vue'

import { AuthActionTypes } from '@/store/modules/auth/actions'

@Component({
  components: {
    AuthModal,
    ForgotPasswordForm,
  },
  head: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
})
export default class ForgotPassword extends Vue {
  get errors() {
    return this.$store.getters.getForgotPasswordPageError
  }

  get formPending() {
    return this.$store.getters.getForgotPasswordPagePending
  }

  onForgotPassword(email: string): void {
    this.$store.dispatch(AuthActionTypes.ForgotPassword, email)
  }
}
